import { Component, Input } from '@angular/core';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'app-visitor-category-pie',
  templateUrl: './visitor-category-pie.component.html',
  styleUrl: './visitor-category-pie.component.scss',
})
export class VisitorCategoryPieComponent {
  @Input() set chartHeight(val: any) {
    if (val) this.height = val + 'px';
  }
  @Input() set chartData(val: any) {
    if (val) {
      this.chartDataDetails = val;
      this.setGraphData(val);
    }
  }
  height = '';
  chartDataDetails: any;
  chartOption: EChartsOption;
  setGraphData(val: any) {
    this.chartOption = {
      tooltip: {
        trigger: 'item',
      },
      legend: {
        top: '5%',
        left: 'center',
      },
      series: [
        {
          name: 'Last 30 Days Visitors',
          type: 'pie',
          radius: ['40%', '70%'],
          avoidLabelOverlap: false,
          padAngle: 5,
          itemStyle: {
            borderRadius: 10,
          },
          label: {
            show: false,
            position: 'center',
          },
          emphasis: {
            label: {
              show: true,
              fontSize: 40,
              fontWeight: 'bold',
            },
          },
          labelLine: {
            show: false,
          },
          data: [
            { value: val.visitorRapidCount, name: 'Rapid Visitor' },
            { value: val.visitorPreVerifiedCount, name: 'Pre-Verified' },
            { value: val.visitorPreApprovedCount, name: 'Pre-Approved' },
            { value: val.visitorGateEntryCount, name: 'Gate Entry' },
          ],
        },
      ],
    };
  }
}
